export default {
	title: 'J\'y pense',
	icon: 'checked.svg',
	grossesse: {
		mois0: [
			{
				text: 'Je vérifie que j\'ai bien déclaré mon médecin traitant pour être bien remboursée.'
			},
			{
				text: 'Je mets à jour ma carte Vitale.'
			},
			{
				text: 'Si mon médecin ou ma sage-femme a déclaré ma grossesse :  <ol><li><b>en ligne</b> : l\'ensemble des informations ont été transmises directement à ma caisse d\'Assurance Maladie et également à ma caisse d\'allocation familiales (CAF). Je n\'ai donc pas de formulaire à compléter ni de courrier à envoyer</li><li><b>sur formulaire papier</b> : je pense à envoyer rapidement les deux volets bleus à votre caisse d\'allocations familiales (CAF)</li></ol>'
			},
			{
				text: 'Le futur papa peut bénéficier d\'un examen de santé pris en charge à 100 % si nécessaire.'
			},
			{
				text: 'Je consulte  <a class="link" target="_blank" href="https://www.ameli.fr/content/ma-maternite-je-prepare-l-arrivee-de-mon-enfant">le guide « ma maternité »</a>.'
			},
			{
				text: 'Il est recommandé d\'être suivie par le même professionnel de santé avant la naissance et lors du retour à domicile.'
			},
			{
				text: 'Vous pouvez créer ou mettre à jour <a class="link" target="_blank" href="https://www.monespacesante.fr/" aria-label="Mon Espace Santé (nouvelle fenêtre)">Mon Espace Santé</a>, un service numérique individuel personnalisable pour gérer vos documents et données de santé en toute sécurité.'
			}
		],
		mois1: [
			{
				text: 'Je vérifie que j\'ai bien déclaré mon médecin traitant pour être bien remboursée.'
			},
			{
				text: 'Je mets à jour ma carte Vitale.'
			},
			{
				text: 'Si mon médecin ou ma sage-femme a déclaré ma grossesse :  <ol><li><b>en ligne</b> : l\'ensemble des informations ont été transmises directement à ma caisse d\'Assurance Maladie et également à ma caisse d\'allocation familiales (CAF). Je n\'ai donc pas de formulaire à compléter ni de courrier à envoyer</li><li><b>sur formulaire papier</b> : je pense à envoyer rapidement les deux volets bleus à ma caisse d\'allocations familiales (CAF)</li></ol>'
			},
			{
				text: 'Le futur papa peut bénéficier d\'un examen de santé pris en charge à 100 % si nécessaire.'
			},
			{
				text: 'Je consulte  <a class="link" target="_blank" href="https://www.ameli.fr/content/ma-maternite-je-prepare-l-arrivee-de-mon-enfant">le guide « ma maternité »</a>.'
			},
			{
				text: 'Il est recommandé d\'être suivie par le même professionnel de santé avant la naissance et lors du retour à domicile.'
			},
			{
				text: 'Vous pouvez créer ou mettre à jour <a class="link" target="_blank" href="https://www.monespacesante.fr/" aria-label="Mon Espace Santé (nouvelle fenêtre)">Mon Espace Santé</a>, un service numérique individuel personnalisable pour gérer vos documents et données de santé en toute sécurité.'
			}
		],
		mois2: [
			{
				text: 'Je vérifie que j\'ai bien déclaré mon médecin traitant pour être bien remboursée.'
			},
			{
				text: 'Je mets à jour ma carte Vitale.'
			},
			{
				text: 'Si mon médecin ou ma sage-femme a déclaré ma grossesse :  <ol><li><b>en ligne</b> : l\'ensemble des informations ont été transmises directement à ma caisse d\'Assurance Maladie et également à ma caisse d\'allocation familiales (CAF). Je n\'ai donc pas de formulaire à compléter ni de courrier à envoyer</li><li><b>sur formulaire papier</b> : je pense à envoyer rapidement les deux volets bleus à ma caisse d\'allocations familiales (CAF)</li></ol>'
			},
			{
				text: 'Le futur papa peut bénéficier d\'un examen de santé pris en charge à 100 % si nécessaire.'
			},
			{
				text: 'Je consulte  <a class="link" target="_blank" href="https://www.ameli.fr/content/ma-maternite-je-prepare-l-arrivee-de-mon-enfant">le guide « ma maternité »</a>.'
			},
			{
				text: 'Il est recommandé d\'être suivie par le même professionnel de santé avant la naissance et lors du retour à domicile.'
			},
			{
				text: 'Vous pouvez créer ou mettre à jour <a class="link" target="_blank" href="https://www.monespacesante.fr/" aria-label="Mon Espace Santé (nouvelle fenêtre)">Mon Espace Santé</a>, un service numérique individuel personnalisable pour gérer vos documents et données de santé en toute sécurité.'
			}
		],
		mois3: [
			{
				text: 'Je conserve toutes mes échographies et résultats d\'analyse pour les rendez-vous suivants.'
			},
			{
				text: 'Dès le début de ma grossesse, je réserve la maternité où je souhaite accoucher.'
			},
			{
				text: 'S\'il ne l\'a pas déjà réalisé, le papa peut bénéficier d\'un examen de santé prise en charge à 100 % si nécessaire.'
			},
			{
				text: 'Je consulte  <a class="link" target="_blank" href="https://www.ameli.fr/content/ma-maternite-je-prepare-l-arrivee-de-mon-enfant">le guide « ma maternité »</a>.'
			},
			{
				text: 'Il est recommandé d\'être suivie par le même professionnel de santé avant la naissance et lors du retour à domicile.'
			},
			{
				text: 'Vous pouvez créer ou mettre à jour <a class="link" target="_blank" href="https://www.monespacesante.fr/" aria-label="Mon Espace Santé (nouvelle fenêtre)">Mon Espace Santé</a>, un service numérique individuel personnalisable pour gérer vos documents et données de santé en toute sécurité.'
			}
		],
		mois4: [
			{
				text: 'Je me renseigne auprès de ma complémentaire santé sur la prise en charge de mon séjour en maternité.'
			},
			{
				text: 'Je consulte  <a class="link" target="_blank" href="https://www.ameli.fr/content/ma-maternite-je-prepare-l-arrivee-de-mon-enfant">le guide « ma maternité »</a>.'
			},
			{
				text: 'Il est recommandé d\'être suivie par le même professionnel de santé avant la naissance et lors du retour à domicile.'
			},
			{
				text: 'Vous pouvez créer ou mettre à jour <a class="link" target="_blank" href="https://www.monespacesante.fr/" aria-label="Mon Espace Santé (nouvelle fenêtre)">Mon Espace Santé</a>, un service numérique individuel personnalisable pour gérer vos documents et données de santé en toute sécurité.'
			}
		],
		mois5: [
			{
				text: 'Je pense à mettre à nouveau à jour ma carte Vitale.'
			},
			{
				text: 'Je me renseigne assez tôt sur la garde envisagée de mon enfant. Je peux consulter les sites <a class="link" target="_blank" href="https://mon-enfant.fr">www.mon-enfant.fr</a> et <a class="link" target="_blank" href="https://www.pajemploi.urssaf.fr">www.pajemploi.urssaf.fr</a>.'
			},
			{
				text: 'Je consulte  <a class="link" target="_blank" href="https://www.ameli.fr/content/ma-maternite-je-prepare-l-arrivee-de-mon-enfant">le guide « ma maternité »</a>.'
			},
			{
				text: 'Il est recommandé d\'être suivie par le même professionnel de santé avant la naissance et lors du retour à domicile.'
			},
			{
				text: 'Vous pouvez créer ou mettre à jour <a class="link" target="_blank" href="https://www.monespacesante.fr/" aria-label="Mon Espace Santé (nouvelle fenêtre)">Mon Espace Santé</a>, un service numérique individuel personnalisable pour gérer vos documents et données de santé en toute sécurité.'
			}
		],
		mois6: [
			{
				text: 'Je consulte  <a class="link" target="_blank" href="https://www.ameli.fr/content/ma-maternite-je-prepare-l-arrivee-de-mon-enfant">le guide « ma maternité »</a>.'
			},
			{
				text: 'Il est recommandé d\'être suivie par le même professionnel de santé avant la naissance et lors du retour à domicile.'
			},
			{
				text: 'Vous pouvez créer ou mettre à jour <a class="link" target="_blank" href="https://www.monespacesante.fr/" aria-label="Mon Espace Santé (nouvelle fenêtre)">Mon Espace Santé</a>, un service numérique individuel personnalisable pour gérer vos documents et données de santé en toute sécurité.'
			}
		],
		mois7: [
			{
				text: 'Je prépare mon séjour à la maternité : je rassemble l\'ensemble de mes analyses et échographies que je devrai apporter le jour de mon accouchement.'
			},
			{
				text: 'Je consulte  <a class="link" target="_blank" href="https://www.ameli.fr/content/ma-maternite-je-prepare-l-arrivee-de-mon-enfant">le guide « ma maternité »</a>.'
			},
			{
				text: 'Il est recommandé d\'être suivie par le même professionnel de santé avant la naissance et lors du retour à domicile.'
			},
			{
				text: 'Vous pouvez créer ou mettre à jour <a class="link" target="_blank" href="https://www.monespacesante.fr/" aria-label="Mon Espace Santé (nouvelle fenêtre)">Mon Espace Santé</a>, un service numérique individuel personnalisable pour gérer vos documents et données de santé en toute sécurité.'
			}
		],
		mois8: [
			{
				text: 'Je prépare mon sac pour la maternité et je ne m\'éloigne pas du lieu de mon accouchement.'
			},
			{
				text: 'Quelques jours après la naissance de mon enfant, je pense à déclarer mon nouveau-né dans mon compte ameli pour l\'inscrire sur ma carte Vitale.'
			},
			{
				text: 'Après la naissance de mon enfant, je pense ensuite à l\'inscrire sur la carte Vitale de son autre parent pour être remboursé plus rapidement. Pour cela, je me rends dans la rubrique "Inscrivez votre enfant sur la carte Vitale des 2 parents" de mon compte ameli.'
			},
			{
				text: 'Il est recommandé d\'être suivie par le même professionnel de santé avant la naissance et lors du retour à domicile.'
			},
			{
				text: 'Vous pouvez créer ou mettre à jour <a class="link" target="_blank" href="https://www.monespacesante.fr/" aria-label="Mon Espace Santé (nouvelle fenêtre)">Mon Espace Santé</a>, un service numérique individuel personnalisable pour gérer vos documents et données de santé en toute sécurité.'
			}
		],
		mois9: [
			{
				text: 'Je prépare mon sac pour la maternité et je ne m\'éloigne pas du lieu de mon accouchement.'
			},
			{
				text: 'Quelques jours après la naissance de mon enfant, je pense à déclarer mon nouveau-né dans mon compte ameli pour l\'inscrire sur ma carte Vitale.'
			},
			{
				text: 'Après la naissance de mon enfant, je pense ensuite à l\'inscrire sur la carte Vitale de son autre parent pour être remboursé plus rapidement. Pour cela, je me rends dans la rubrique "Inscrivez votre enfant sur la carte Vitale des 2 parents" de mon compte ameli.'
			},
			{
				text: 'Il est recommandé d\'être suivie par le même professionnel de santé avant la naissance et lors du retour à domicile.'
			},
			{
				text: 'Vous pouvez créer ou mettre à jour <a class="link" target="_blank" href="https://www.monespacesante.fr/" aria-label="Mon Espace Santé (nouvelle fenêtre)">Mon Espace Santé</a>, un service numérique individuel personnalisable pour gérer vos documents et données de santé en toute sécurité.'
			}
		]
	}
}
